<template>
  <li>
    <strong>{{this.nameWithCommaIfDescription}}</strong>
    {{this.item.description}} {{price}}
  </li>
</template>

<script>
export default {
  props: ["item"],
  computed: {
    price() {
      return this.item.choices.length > 0
        ? this.item.choices[0].prices.min
        : null;
    },
    nameWithCommaIfDescription() {
      return this.item.description ? this.item.name + "." : this.item.name;
    },
    priceWithPipePrefix() {
      return this.price ? " | " + this.price : null;
    }
  }
};
</script>
